// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {switchMap} from 'rxjs/operators';
import {UserService} from '../../../services/user-service';
import {IInvitationResponse} from '../../../types/user';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Partners } from '../../../types/partners';
import { ConfigurationService } from '../../../services/configuration-service';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-invitation',
    templateUrl: './invitation.component.html',
    styleUrls: ['./invitation.component.scss'],
    standalone: false
})
export class InvitationComponent implements OnInit {
  invitationResponse: IInvitationResponse;
  invitationUUID = '';
  errorFindingInvitation = false;
  cigentPartner = Partners.Cigent;
  doqubizPartner = Partners.Doqubiz;
  digistorPartner = Partners.Digistor;
  kanguruPartner = Partners.Kanguru;
  lenovoPartner = Partners.Lenovo;
  partnerId: Partners = Partners.Cigent;

  fExpired: string
  fHere: string
  fNotFound: string;
  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private readonly configuration: ConfigurationService
  ) {
    this.translate.get(['IN_EXPIRED', 'IN_HERE', 'IN_NOT_FOUND']).subscribe(vals => {
      this.fExpired = vals['IN_EXPIRED'];
      this.fHere = vals['IN_HERE'];
      this.fNotFound = vals['IN_NOT_FOUND'];
    });
    this.partnerId = this.configuration.partnerId ?? Partners.Cigent;
  }

  ngOnInit() {
    this.route.paramMap.pipe(
        switchMap((params: ParamMap) => {
          this.invitationUUID = params.get('uuid');
          return this.userService.api_get_user_by_invitation(this.invitationUUID);
        })
    ).subscribe(
        response => this.invitationResponse = response,
        error => this.errorFindingInvitation = true
    );
  }

}
